import e from"../../node_modules/lodash-es/merge.js";var o=(o,r)=>e({},o,r);export{o as extendLocale};
//# sourceMappingURL=extendLocale.js.map